export default __webpack_public_path__ + "static/media/명지서법.01c45a9e.svg";